import { FederatedIdentity } from '../utils/AccessCredentials/FederatedIdentity';
import UserLogin from '../utils/UserLogin/UserLogin';
import { encrypt } from '../utils/Helper/encryption';
import { useAppDispatch } from './storeHooks';
import { updateUserData } from '../store/slice/sessionSlice';

interface AWSCredentials {
  AccessKeyId: string;
  SecretAccessKey: string;
  SessionToken: string;
}

interface UseSessionRefreshParams {
  userPoolId: string;
  identityPoolId: string;
  email: string;
}

export const useSessionRefresh = ({
  userPoolId,
  identityPoolId,
  email
}: UseSessionRefreshParams) => {
  const dispatch = useAppDispatch();
  const refreshSessionAndGetCredentials = async (): Promise<AWSCredentials | null> => {
    const encryptedPassword = sessionStorage.getItem('userPassword');
    const storedEmail = sessionStorage.getItem('userEmail');
    if (!encryptedPassword || !storedEmail) return null;
    const userLoginObj = new UserLogin({ email: storedEmail, password: encryptedPassword });
    const loginStatus = await userLoginObj.doLogin('');
    if (loginStatus.statusCode !== 201) return null;
    const responseData: any = loginStatus.body;
    sessionStorage.setItem('loginToken', encrypt(JSON.stringify(responseData)));
    dispatch(updateUserData(JSON.stringify(responseData)));
    const newIdToken = responseData.cognitoDetails.message.idToken.jwtToken;
    const role = responseData.cognitoDetails.message.idToken.payload['cognito:preferred_role'];
    const newFederatedIdentity = new FederatedIdentity({ userPoolId, identityPoolId });
    const retryResponse = await newFederatedIdentity.fetchAWSCredentials(newIdToken, email, role);
    return retryResponse?.body?.data?.Credentials ?? null;
  };

  return { refreshSessionAndGetCredentials };
};
